import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { DocumentStatusPayload } from '~bank-reports/routes/DocumentStatusReport/types'

export const documentStatusReportQueryOptions = (deps: Partial<DocumentStatusPayload>) =>
  queryOptions({
    queryKey: ['documentStatusReport', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportDocumentStatus, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
